import { render, staticRenderFns } from "./SurveysTable.vue?vue&type=template&id=59797d4d&"
import script from "./SurveysTable.vue?vue&type=script&lang=ts&"
export * from "./SurveysTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
